import React, { useState, useEffect, useRef } from "react";
import Masonry from "masonry-layout";
import useAuth from "../../Hooks/useAuth";

// Customer Dashboard Widgets
import LocalTradesTrendingServicesWidget from "../../components/CustomerDashboard/LocalTradesTrendingServicesWidget";
import SavedPostsWidget from "../../components/CustomerDashboard/SavedPostsWidget";
import MessagesWidget from "../../components/CustomerDashboard/MessagesWidget";
import FollowedBusinessesWidget from "../../components/CustomerDashboard/FollowedBusinessesWidget";
import ReviewsWidget from "../../components/CustomerDashboard/ReviewsWidget";
import ActivityFeedWidget from "../../components/CustomerDashboard/ActivityFeedWidget";
import AccountInfoWidget from "../../components/CustomerDashboard/AccountInfoWidget";

const CustomerDasboard = () => {
  const { auth } = useAuth();
  const masonryGridRef = useRef(null);

  // Initialize Masonry layout
  useEffect(() => {
    if (masonryGridRef.current) {
      try {
        // Wait for images to load before initializing masonry
        const images = masonryGridRef.current.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        });

        Promise.all(imagePromises).then(() => {
          if (masonryGridRef.current && typeof Masonry !== 'undefined') {
            try {
              const masonry = new Masonry(masonryGridRef.current, {
                itemSelector: '.masonry-item',
                columnWidth: 10,
                gutter: 0, // 16px gutter
              });

              // Re-layout on window resize
              const handleResize = () => {
                if (masonry && masonry.layout) {
                  masonry.layout();
                }
              };

              window.addEventListener('resize', handleResize);

              // Store masonry instance for cleanup
              if (masonryGridRef.current) {
                masonryGridRef.current.masonry = masonry;
              }

              return () => {
                window.removeEventListener('resize', handleResize);
                if (masonryGridRef.current?.masonry) {
                  masonryGridRef.current.masonry.destroy();
                }
              };
            } catch (error) {
              console.warn('Failed to initialize Masonry:', error);
            }
          }
        }).catch(error => {
          console.warn('Failed to load images for Masonry:', error);
        });
      } catch (error) {
        console.warn('Failed to setup Masonry:', error);
      }
    }
  }, []);

  // Cleanup masonry on unmount
  useEffect(() => {
    return () => {
      if (masonryGridRef.current?.masonry) {
        masonryGridRef.current.masonry.destroy();
      }
    };
  }, []);

  return (
    <>
      {/* Grid Layout for Customer Dashboard Widgets */}
      <div ref={masonryGridRef} className="masonry-grid">
        <LocalTradesTrendingServicesWidget />
        <SavedPostsWidget />
        <FollowedBusinessesWidget />
        <MessagesWidget />
        <ReviewsWidget />
        <ActivityFeedWidget />
        <AccountInfoWidget />
      </div>
    </>
  );
};

export default CustomerDasboard;